import Compressor from "compressorjs";

// eslint-disable-next-line import/prefer-default-export
export const compressImages = file =>
  new Promise(res => {
    const existingSizeMB = file.size * 0.000001;
    if (existingSizeMB < 1) {
      res(file);
    }

    // reduce quality if size above 1MB
    const quality = existingSizeMB > 1 ? 0.8 : 1;
    // eslint-disable-next-line no-new
    new Compressor(file, {
      quality,
      maxWidth: 1024,
      maxHeight: 1500,
      success(result) {
        // console.debug("RES", result);
        const resFile = new File([result], result.name);
        res(resFile);
      },
      error(err) {
        console.error(err.message);
        res(file);
      },
    });
  });
